import React, { useState, useEffect } from 'react';
import { Container, Row, Card, CardBody, Col } from 'reactstrap';
import { useParams, useHistory } from 'react-router';
import { toast } from 'react-toastify';
import Api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import { partial } from '../../util/translation/translation';
import useConfig from '../../util/useConfig';
import PaymentOptionForm from './PaymentOptionForm';
import moment from 'moment';
import { formatDate } from '../../util/date-and-time';
import clubConfig from '../../config';

const PaymentOptionsFormPage = () => {
  const { entityType, optionId, externalEntityId } = useParams();
  const tessss = useParams();

  const history = useHistory();

  const p = partial('paymentOptions');
  const s = partial('shared');

  const [loading, setLoading] = useState(false);
  const [loadingExternalEntity, setLoadingExternalEntity] = useState(false);

  const [externalEntity, setExternalEntity] = useState(externalEntityId);
  const [externalEntityName, setExternalEntityName] = useState(null);

  const [paymentOption, setPaymentOption] = useState(null);
  const config = useConfig();
  const getPaymentOption = async () => {
    setLoading(true);
    try {
      const resPaymentOption =
        await Api.transactions.getPaymentOption(optionId);
      setExternalEntity(resPaymentOption.entityId);
      setPaymentOption(resPaymentOption);
      setLoading(false);
    } catch (err) {
      toast.error(p('paymentOptionRetrievingERROR'));
      setLoading(false);
    }
  };

  const getExternalEntity = async () => {
    setLoadingExternalEntity(true);
    try {
      switch (entityType) {
        case 'tier':
          const resTier = await Api.tiers.getTier(externalEntity);
          setExternalEntityName(resTier.data.name);
          break;
        case 'goal_subscription':
          const resGoalSubscription =
            await Api.goalSponsor.subscriptionPlans.getSubscriptionPlanById(
              externalEntity
            );
          console.log(resGoalSubscription);
          setExternalEntityName(resGoalSubscription.name);
          break;
        default:
          setExternalEntityName('');
          break;
      }
      setLoadingExternalEntity(false);
    } catch (err) {
      toast.error(p('paymentOptionRetrievingERROR'));
      setLoadingExternalEntity(false);
    }
  };

  useEffect(() => {
    if (optionId) {
      getPaymentOption();
    }
  }, [optionId]);
  useEffect(() => {
    if (externalEntity) {
      getExternalEntity();
    }
  }, [externalEntity]);
  const getBackUrl = () => {
    switch (entityType) {
      case 'tier':
        return `/user_tiers/edit/${externalEntity}?tab=2`;
      case 'goal_subscription':
        return `/goal-sponsor/subscription-plans/edit/${externalEntity}?tab=6`;
      default:
        return null;
    }
  };
  const constructName = (values) => {
    switch (values.paymentType.value) {
      case 'subscription':
        if (entityType === 'goal_subscription') {
          return p('subscriptionPaymentForGoalSubscription', {
            entityName: externalEntityName,
          });
        } else {
          return p('subscriptionPaymentFor', {
            entityName: externalEntityName,
            interval: values.optionValue,
          });
        }

      case 'one_time':
        switch (values.optionType.value) {
          case 'till_date':
            return p('oneTimePaymentUntil', {
              entityName: externalEntityName,
              date: formatDate(values.optionValue),
            });

          case 'months':
            return p('oneTimePaymentFor', {
              entityName: externalEntityName,
              interval: values.optionValue,
            });
          default:
            return null;
        }
      default:
        return null;
    }
  };
  const onSubmit = async (values) => {
    const clubVat = clubConfig.vat || 0;
    const payload = {
      entityId: externalEntity,
      entityName: externalEntityName,
      entityType: entityType,
      providerType: values.providerType.value,
      paymentType: values.paymentType.value,
      price: values?.grossPrice * 100,
      currency: config.currencyCaps,
      optionType: values.optionType.value,
      optionValue: values.optionValue,
      optionName: constructName(values),
      isActive: values.isActive || false,
      vat: Number(clubVat),
      // Tiers only; left out elsewhere so they stay unchanged. Sales end at
      // the end of the picked day; empty sends null so a cleared value is removed
      ...(entityType === 'tier' && {
        salesEndDate: values.salesEndDate
          ? moment(values.salesEndDate).endOf('day').toISOString()
          : null,
        badgeText: values.badgeText?.trim() || null,
      }),
    };

    setLoading(true);
    try {
      if (optionId) {
        await Api.transactions.updatePaymentOption(optionId, payload);
        setLoading(false);
        toast.success(`${p('paymentOptionUpdated')}`);
        history.push(getBackUrl());
      } else {
        await Api.transactions.createPaymentOption(payload);
        toast.success(`${p('paymentOptionCreated')}`);
        history.push(getBackUrl());
      }
    } catch (err) {
      toast.error(s('somethingWentWrong'));
      setLoading(false);
    }
  };
  return (
    <Container>
      <Loading loading={loading || loadingExternalEntity} />
      <Row>
        <Col>
          <h3 className="page-title">
            {`${optionId ? `${s('edit')}` : `${s('create')}`} ${p('paymentOption')}-${externalEntityName}`}
          </h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardBody className="p-0">
              <PaymentOptionForm
                paymentOption={paymentOption}
                backUrl={getBackUrl()}
                type={optionId ? 'edit' : 'create'}
                entityType={entityType}
                onSubmit={onSubmit}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentOptionsFormPage;
